import { render, staticRenderFns } from "./EmbedPBD.vue?vue&type=template&id=7bb34da4&scoped=true&"
import script from "./EmbedPBD.vue?vue&type=script&lang=js&"
export * from "./EmbedPBD.vue?vue&type=script&lang=js&"
import style0 from "./EmbedPBD.vue?vue&type=style&index=0&id=7bb34da4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb34da4",
  null
  
)

export default component.exports